import styled, { css } from 'styled-components'
import { CheckmarkIcon, colors } from '@chegg-ui/theme'
import { Link } from '@chegg/fanta'
import { SpecialOutlineButtonLink } from '@chegg-wt/core/theme/fanta/button'
import fanta from '@chegg-wt/core/theme/fanta/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const H2 = styled.h2`
  font-weight: ${fanta.font.weight.extraBold};
  font-size: ${fanta.font.text.size.xlg};
  margin: ${fanta.spacing.fanta.lg};
`

export const ECContent = styled.div`
  width: 100%;
`

export const PanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.white};
  width: 100%;
  padding: 24px;
  padding-top: 0;
  align-items: center;
`

export const PlagiarismContainer = styled.div`
  background-color: ${colors.white};
  width: 100%;
  padding: 24px;
  padding-top: 0;
  > h2 {
    margin-left: 0;
  }
`

export const ECContainer = styled(PanelContainer)`
  > h2 {
    margin-top: 20px;
    margin-bottom: 24px;
  }
`

export const SuccessIcon = styled(CheckmarkIcon).attrs({
  color: colors.cheggOrange,
})<{ GP: boolean }>`
  position: absolute;
  margin: ${({ GP }) => (GP ? '-11px -10px' : '-9px 0')};
`

export const FeatureListContainer = styled.ul`
  width: 450px; /* allow this list to be more centered and share consistent styling for different sized lists */

  @media (max-width: 999px) {
    width: auto;
  }
`

export const FeatureListItem = styled.li<{ GP: boolean }>`
  position: relative;
  list-style: none;
  text-align: start;
  ${AspiraStack};
  font-size: ${fanta.font.text.size.md};
  font-weight: 500;
  line-height: 20px;
  margin-top: 16px;
  &:first-child {
    margin-top: 0px;
  }
`

export const CTAButton = styled(SpecialOutlineButtonLink)`
  margin-top: 24px;
`

export const CitationsCTAButton = styled(SpecialOutlineButtonLink)`
  margin-top: ${fanta.spacing.fanta.lg};
`

export const FeatureText = styled.span``

export const PanelHeading = styled(H2)<{ center?: boolean }>`
  ${({ center }) =>
    center &&
    css`
      align-self: center;
    `}
`

export const PanelCTAHeading = styled.div`
  font-weight: ${fanta.font.weight.extraBold};
  font-size: ${fanta.font.text.size['2xl']};
  margin-bottom: ${fanta.spacing.fanta.lg};
  align-self: center;
`

export const PanelSubHeading = styled.div`
  margin-bottom: 24px;
  align-self: center;
`

export const SignInLink = styled(Link)`
  &&& {
    color: ${colors.teal};
    &:visited:hover:focus {
      color: ${colors.tealLight};
    }
    ${AspiraStack};
    height: 12px;
    font-size: ${fanta.font.text.size.md};
    letter-spacing: 0;
    line-height: ${fanta.spacing.fanta.md};
    font-weight: ${fanta.font.weight.extraBold};
  }
`
export const SignInWrapper = styled.p`
  display: flex;
  align-items: center;
  padding-top: ${fanta.spacing.fanta.xl};
`

export const ECHeading = styled(PanelHeading)`
  text-align: center;
  margin: 0 auto;
`

export const PlagiarizedPaperImage = styled.img`
  display: none;
  @media (min-width: 480px) {
    display: inline-block;
    height: 152px;
    width: 120px;
  }
`

export const PaddingWrapper = styled.div`
  padding-left: 37px;
`

export const GPContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
`

export const GPFeatureWrapper = styled.div`
  @media (min-width: 480px) {
    padding-left: 24px;
  }
`

export const TermsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;
`
